import './features.component.scss'
import { breakpoints } from '../../application/utils/breakpoints'
import { Swiper, Pagination } from 'swiper'
import { matchMedia } from '../../application/utils/machMedia'
Swiper.use(Pagination)

document.querySelectorAll('.features').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  const options = {
    slidesPerView: 1,
    spaceBetween: 16,
    autoHeight: true,
    allowTouchMove: true,
    pagination: {
      el: root.querySelector('.swiper-pagination'),
      clickable: true
    },
    breakpoints: {
      [breakpoints.medium]: {
        slidesPerView: 3,
        autoHeight: false,
        allowTouchMove: false
      },
      [breakpoints.tablet - 1]: {
        slidesPerView: 2,
        autoHeight: false,
        allowTouchMove: true
      }
    }
  }
  let swiperInstance = new Swiper(swiperElement, options)

  matchMedia('(orientation: portrait)')(() => {
    swiperInstance.destroy(true, true)
    swiperInstance = new Swiper(swiperElement, options)
  })
})
